import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Form, Row } from "react-bootstrap";
import { Grid } from "@mui/material";
import { IoMdArrowBack } from "react-icons/io";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useFormik } from 'formik';
import * as yup from 'yup';
import toast from "react-hot-toast";
import { createUser } from "../../api/context/users";



export const CreateUser = () => {

    const navigate = useNavigate();

    const { id } = useParams()

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState({
        password: false,
    });

    const togglePasswordVisibility = (fieldName) => {
        setShowPassword(prev => ({ ...prev, [fieldName]: !prev[fieldName] }));
    };

    const validationSchema = yup.object().shape({
        username: yup.string('').required('Required'),
        password: yup.string('').required('Required'),
    });

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                createUser(values)((response) => {
                    console.log(response, 'response');
                    if (response && response?.data?.status_code === 201) {
                        setLoading(false);
                        resetForm();
                        toast.success("User Created Successfully")
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.error_message);
                    }
                })
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        },
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
    };


    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center">
                        {/* <Link to='/users' className='back_btn_wrap'>
                            <IoMdArrowBack className='icon' />
                        </Link> */}
                        <h4 className="mb-sm-0">{id ? 'Edit' : 'Create'} User</h4>
                    </div>
                </div>
            </div>
            <div className="pe-2">
                <Form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <div className="create-form-card">
                            <Row>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>User Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter first name"
                                            name='username'
                                            value={formik.values?.username}
                                            onChange={handleInputChange}
                                            isValid={formik.touched.username && !formik.errors.username}
                                            isInvalid={formik.touched.username && !!formik.errors.username}
                                        />
                                        <Form.Control.Feedback type="invalid">{formik.errors.username}</Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Password</Form.Label>
                                        <div className='eye_icon_wrapper'>
                                            <Form.Control
                                                type={showPassword.password ? 'text' : 'password'}
                                                placeholder=""
                                                name='password'
                                                value={formik.values?.password}
                                                onChange={handleInputChange}
                                                isValid={formik.touched.password && !formik.errors.password}
                                                isInvalid={formik.touched.password && !!formik.errors.password}
                                            />
                                            <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                                            {showPassword.password ? (
                                                <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                            ) : (
                                                <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                            )}
                                        </div>

                                    </Form.Group>
                                </div>
                            </Row>
                        </div>
                    </div>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className='create-btn-grid'>
                        <Button className='save_btn' type="submit" disabled={loading}>
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    {loading ? "Loading" : id ? "Update" : "Save"}
                                </div>
                            </div>
                        </Button>

                    </Grid>

                </Form>
            </div>

        </>
    );
};
